// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"216134c4","281":"8e1ddd54","306":"00813317","479":"75c1ada1","560":"0f227a27","761":"a2ad8191","874":"e9896c2d"}[chunkId] + ".css";
};